<template>
  <div
    v-clickoutside="$_onDropdownClose"
    :class="wrapClasses"
    @mouseenter="$_onDropdownMouseenter"
    @mouseleave="$_onDropdownMouseleave">
    <div ref="reference" @click.stop="$_onDropdownClick" >
      <slot></slot>
    </div>
    <!--<transition :name="transition">-->
    <t-pop-box v-show="currentVisible" ref="drop" :placement="placement"
               @mouseenter.native="$_onDropdownMouseenter"
               @mouseleave.native="$_onDropdownMouseleave">
      <slot name="list">
      </slot>
    </t-pop-box>
    <!--</transition>-->
  </div>
</template>
<script>
import clickoutside from '../../directives/clickoutside'
import { findComponentUpward } from '../../utils/assist'
import Emitter from '../../mixins/emitter'
import TPopBox from '../pop-box/pop-box.vue'

const PREFIXCLS = 'popover'
let prevInstance = null // trigger为click时的前一个弹出实例

export default {
  name: 'TDropdown',
  directives: { clickoutside },
  components: { TPopBox },
  mixins: [Emitter],
  props: {
    trigger: {
      type: String,
      validator(value) {
        return ['click', 'hover', 'custom'].includes(value)
      },
      default: 'hover'
    },
    visible: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      validator(value) {
        return [
          'top',
          'top-start',
          'top-end',
          'bottom',
          'bottom-start',
          'bottom-end',
          'left',
          'left-start',
          'left-end',
          'right',
          'right-start',
          'right-end'
        ].includes(value)
      },
      default: 'bottom'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentVisible: this.visible
    }
  },
  computed: {
    transition() {
      return ['bottom-start', 'bottom', 'bottom-end'].indexOf(this.placement) >
        -1
        ? 'slide-up'
        : 'fade'
    },
    wrapClasses() {
      return [
        `${PREFIXCLS}-wrap`,
        {
          // [`dropup`]: this.placement ==='top',
          // [`dropright`]: this.placement ==='right',
          // [`dropleft`]: this.placement ==='left',
          [`${PREFIXCLS}--open`]: this.currentVisible,
          [`${PREFIXCLS}--disabled`]: this.disabled
        }
      ]
    }
  },
  watch: {
    visible(val) {
      this.currentVisible = val
    },
    currentVisible(val) {
      if (val) {
        this.$refs.drop.update()
      }
      this.$emit('on-visible-change', val)
    }
  },
  mounted() {
    this.$on('on-click', key => {
      key = key || ''
      const $parent = this.$_hasParent()
      if ($parent) $parent.$emit('on-click', key)
      this.broadcast('TDropdownItem', 'on-selected-change', key)
    })
    this.$on('on-hover-click', () => {
      const $parent = this.$_hasParent()
      if ($parent) {
        this.$nextTick(() => {
          if (this.trigger === 'custom') return false
          this.currentVisible = false
        })
        $parent.$emit('on-hover-click')
      } else {
        this.$nextTick(() => {
          if (this.trigger === 'custom') return false
          this.currentVisible = false
        })
      }
    })
    this.$on('on-haschild-click', () => {
      this.$nextTick(() => {
        if (this.trigger === 'custom') return false
        this.currentVisible = true
      })
      const $parent = this.$_hasParent()
      if ($parent) $parent.$emit('on-haschild-click')
    })
  },
  beforeDestroy() {
    prevInstance = null // 释放引用
  },
  methods: {
    $_isChildren(instance) {
      let parent = this.$parent
      while (parent) {
        if (parent === instance) {
          return true
        }
        parent = parent.$parent
      }
      return false
    },
    $_resetPrevInstanceState() {
      if (prevInstance !== null && prevInstance !== this) {
        let isChildren = this.$_isChildren(prevInstance)
        if (isChildren === false) {
          prevInstance.currentVisible = false
        }
      }
      prevInstance = this
    },
    $_onDropdownClick() {
      if (this.trigger !== 'click' || this.disabled) {
        return false
      }
      this.$_resetPrevInstanceState()
      this.currentVisible = !this.currentVisible
    },
    $_onDropdownMouseenter() {
      if (this.trigger !== 'hover' || this.disabled) {
        return false
      }
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.$_resetPrevInstanceState()
        this.currentVisible = true
      }, 250)
    },
    $_onDropdownMouseleave() {
      if (this.trigger !== 'hover') {
        return false
      }
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.currentVisible = false
      }, 150)
    },
    $_onDropdownClose(event) {
      if (this.trigger === 'custom') return false
      if (this.trigger !== 'click') {
        return false
      }
      if (
        this.trigger === 'click' &&
        event.target.className === 'dropdown__item'
      ) {
        return false
      }
      this.currentVisible = false
    },
    $_hasParent() {
      const $parent = findComponentUpward(this, 'TDropdown')
      if ($parent) {
        return $parent
      } else {
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// dropdown.vue?7d1d1a56